'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { Home, Calendar, MessageSquare, Bot, BarChart3 } from 'lucide-react';

const TABS = [
    { href: '/', label: '홈', icon: Home },
    { href: '/scheduler', label: '스케줄', icon: Calendar },
    { href: '/chat', label: '챗', icon: MessageSquare },
    { href: '/agent', label: '에이전트', icon: Bot },
    { href: '/usage', label: '분석', icon: BarChart3 },
];

export function MobileTabBar() {
    const pathname = usePathname();

    return (
        <nav className="fixed bottom-0 left-0 right-0 z-50 lg:hidden">
            <div className="bg-gray-950/95 backdrop-blur-xl border-t border-white/10 safe-area-bottom">
                <div className="flex items-center justify-around h-14 max-w-lg mx-auto">
                    {TABS.map(tab => {
                        const isActive = tab.href === '/' ? pathname === '/' : pathname.startsWith(tab.href);
                        const Icon = tab.icon;
                        return (
                            <Link key={tab.href} href={tab.href}
                                className={`flex flex-col items-center justify-center gap-0.5 px-3 py-1.5 rounded-xl transition-all ${
                                    isActive ? 'text-blue-400' : 'text-gray-500'
                                }`}>
                                <Icon className={`w-5 h-5 ${isActive ? 'scale-110' : ''} transition-transform`} />
                                <span className="text-[9px] font-medium">{tab.label}</span>
                                {isActive && (
                                    <div className="absolute top-0 left-1/2 -translate-x-1/2 w-6 h-0.5 rounded-full bg-blue-400" />
                                )}
                            </Link>
                        );
                    })}
                </div>
            </div>
        </nav>
    );
}
